import { createFileRoute } from "@tanstack/react-router"
import { SurveyShell } from "~/components/survey/SurveyShell"

export const Route = createFileRoute("/survey")({
  component: SurveyPage,
})

function SurveyPage() {
  return <SurveyShell />
}
